import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import "@/App.css";

import ScrollToTop from "@/components/ScrollToTop";
import BrandLogo from "@/components/BrandLogo";
import NetworkPulse from "@/components/NetworkPulse";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import AppRoutes from "@/routes/AppRoutes";

function PageFallback() {
  return (
    <div className="container-x pt-32 pb-32 flex flex-col items-center justify-center" data-testid="route-fallback">
      <BrandLogo variant="symbol" size={48} className="brand-symbol-pulse" />
      <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.28em] text-muted-foreground">
        Loading the network…
      </p>
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <NetworkPulse />
          <Suspense fallback={<PageFallback />}>
            <AppRoutes />
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
